module.exports = __webpack_public_path__ + "img/google-app-search.369f52ea.webp";